import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // Initialiser i18n AVANT App
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={
      <div className="min-h-screen bg-mutagim-dark flex items-center justify-center">
        <div className="text-white">Chargement...</div>
      </div>
    }>
      <App />
    </Suspense>
  </React.StrictMode>,
);
